import { type MainPoiCategory, mainPoiCategoryList } from '$lib/components/pois/types';

export function match(value: string): value is MainPoiCategory {
	return mainPoiCategoryList.includes(value as MainPoiCategory);
}

export interface ParamsWithCategory {
	category?: MainPoiCategory;
}

export function paramsHasCategory(params: Record<string, any>): params is ParamsWithCategory {
	return 'category' in params;
}
